import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';

import { useAuthContext } from '@myphx-engineering/auth/client';
import {
    Body1,
    Button,
    Flex,
    Image,
    Stack,
    Title1,
} from '@myphx-engineering/phx-design-system';

import { useAppMaintenanceStatus } from '../../../hooks/use-app-maintenance-status';

export const MedicationsDeliveredHeader = () => {
    const { t } = useTranslation();
    const { disableAuthFlows, signUp } = useAuthContext();
    const location = useLocation();
    const { isMaintenanceActive } = useAppMaintenanceStatus();

    return (
        <Stack gap="lg" py="xxl">
            <Image src="/static/img/lilly-unauth-header.png" />
            <Stack>
                <Title1 ta="center">{t('unauth.home.title')}</Title1>
                <Body1 ta="center">{t('unauth.home.description')}</Body1>
                <Flex justify="center">
                    <Button
                        onClick={() => signUp(location.pathname)}
                        disabled={isMaintenanceActive || disableAuthFlows}
                    >
                        {t('unauth.home.button')}
                    </Button>
                </Flex>
            </Stack>
        </Stack>
    );
};
